import globals from "@homer.core/globals";
import page from "@homer.core/page";

const url = URL.resolve(location.href);
const hash = url.parameter?.followup?.unsubscribe;

if (hash) {
    url.searchParams.delete("followup[unsubscribe]");
    page.replace(url.href);

    void globals.demand.request("@schema/webpageelement.dialog.followup").then(([FollowupDialog]) => {
        return new FollowupDialog({ hash });
    });
}
